module.exports = __webpack_public_path__ + "static/media/alexa.925e7937.png";